export default __webpack_public_path__ + "static/media/Login.915fc359.png";